import { GET_RECENT_RESOURCES } from "./constants";

const init = {
  recentResources: {
    accounting: {
      recentlyDownloaded: [],
      recentltyViewed: [],
    },
    marketing: {
      recentlyDownloaded: [],
      recentltyViewed: [],
    },
    business: {
      recentlyDownloaded: [],
      recentltyViewed: [],
    },
    clientCare: {
      recentlyDownloaded: [],
      recentltyViewed: [],
    },
    technology: {
      recentlyDownloaded: [],
      recentltyViewed: [],
    },
  },
};

const recentResourcesReducer = (state = init, action) => {
  if (action.type === GET_RECENT_RESOURCES) {
    return {
      ...state,
      recentResources: { ...action?.payload },
    }; 
  }
  return state;
};
export default recentResourcesReducer;
